var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "grid-940-1 mt20"
  }, [_c('div', {
    staticClass: "loginpage-left",
    attrs: {
      "id": "div_left"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginpage-right"
  }, [_c('form', [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "backUrl",
      "value": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "qualifyType",
      "value": "002001"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "clientType",
      "value": "uc"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "exchangeId",
      "value": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "loginpage-title"
  }, [_c('span', {
    staticClass: "Login_Span_1",
    class: {
      'Cur': _vm.isPwdActive
    },
    attrs: {
      "id": "tagPwd"
    },
    on: {
      "click": function($event) {
        _vm.changeTagFun('tagPwd')
      }
    }
  }, [_vm._v("密码登录")]), _vm._v(" "), _c('span', {
    staticClass: "Login_Span_2",
    class: {
      'Cur': _vm.isMobileActive
    },
    attrs: {
      "id": "tagMobile"
    },
    on: {
      "click": function($event) {
        _vm.changeTagFun('tagMobile')
      }
    }
  }, [_vm._v("手机验证码登录")])]), _vm._v(" "), (_vm.changeTag === 'tagPwdContent') ? _c('table', {
    staticClass: "loginpage-table Cur",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "login_th"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "account_font"
    }
  }, [_vm._v("*")]), _vm._v("登录账号 ：")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "login_th"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "p_font"
    }
  }, [_vm._v("*")]), _vm._v("登录密码：")], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "btn-loginpage cur",
    attrs: {
      "type": "button",
      "value": "登 录"
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }), _vm._v("    \n\t\t\t\t          ")])])])]) : _vm._e(), _vm._v(" "), (_vm.changeTag === 'tagMobileContent') ? _c('table', {
    staticClass: "loginpage-table Cur",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "login_th_1"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "account_font"
    }
  }, [_vm._v("*")]), _vm._v("手机号 ：")], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "login_th_1"
  }, [_c('font', {
    staticClass: "loginpage-star",
    attrs: {
      "id": "p_font"
    }
  }, [_vm._v("*")]), _vm._v("验证码：")], 1), _vm._v(" "), _c('td', {
    staticClass: "login_td_1"
  }, [_c('input', {
    staticClass: "input-txt",
    attrs: {
      "id": "checkCode",
      "name": "checkCode",
      "value": "",
      "type": "password",
      "maxlength": "20"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mui-btn mr10 f12 login_button",
    attrs: {
      "type": "button",
      "id": "buttonView"
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("获取验证码")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('input', {
    staticClass: "btn-loginpage cur",
    attrs: {
      "type": "button",
      "value": "登 录"
    },
    on: {
      "click": function($event) {
        _vm.mobileLogin()
      }
    }
  }), _vm._v("    \n\t\t\t\t          ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "clr"
  })])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td"
  }, [_c('input', {
    staticClass: "input-txt",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "id": "account",
      "name": "account",
      "value": "",
      "maxlength": "256"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td"
  }, [_c('input', {
    staticClass: "input-txt",
    attrs: {
      "id": "password",
      "name": "password",
      "value": "",
      "type": "password",
      "maxlength": "20"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "login_td_1"
  }, [_c('input', {
    staticClass: "input-txt",
    staticStyle: {
      "color": "#000000"
    },
    attrs: {
      "type": "text",
      "id": "mobile",
      "name": "mobile",
      "value": "",
      "maxlength": "256"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc71e45a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/login/login.vue
// module id = H6cY
// module chunks = 1